import store from '@/store'
import { computed, ComputedRef, onMounted, onUnmounted, Ref, watch } from '@vue/composition-api'
import { Cast } from '../classes'

const useSubscribedCast = (castId: Ref<string|null>) => {
  const cast: ComputedRef<Cast|null> = computed(() => store.state.casts.subscribedCasts[castId.value ?? ''] ?? null)

  onMounted(async () => {
    if (castId.value) {
      const result = await store.dispatch.casts.subscribeCast(castId.value)
      result.logIfError(`Error subscribing to cast ${castId.value}`)
    }
  })

  onUnmounted(async () => {
    if (castId.value) await store.dispatch.casts.unsubscribeCast(castId.value)
  })

  watch(castId, async (newVal, oldVal) => {
    if (oldVal) await store.dispatch.casts.unsubscribeCast(oldVal)
    if (newVal) {
      const result = await store.dispatch.casts.subscribeCast(newVal)
      result.logIfError(`Error subscribing to cast ${newVal}`)
    }
  })

  return {
    cast
  }
}

export default useSubscribedCast
